import React from 'react';
import { Navigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import RegisterForm from '../components/Auth/RegisterForm';
import TrovaBrand from '../components/Auth/TrovaBrand';
import { useAuth } from '../contexts/AuthContext';

const RegisterPage: React.FC = () => {
  const { user, loading } = useAuth();
  
  // If user is already logged in, redirect to dashboard
  if (user && !loading) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return (
    <div className="login-page">
      <Helmet>
        <title>Create Account</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="login-container">
        <div className="login-header">
          <TrovaBrand />
          <h2 className="login-title">Create Account</h2>
          <p className="login-subtitle">
            Join Trova to streamline your hiring process
          </p>
        </div>

        <div className="login-form-container">
          <RegisterForm />
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
